import React from "react";
import { Box } from "@mui/material";

import {
  ArrowDownward,
  ArrowUpward,
  FiberManualRecord,
} from "@mui/icons-material";
import useStyles from "./styles";
import { Colors } from "@/theme";

const PriceTrend = ({ trend, fontSize }) => {
  const classes = useStyles();
  const roundedTrend = parseFloat(trend || "0");

  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      sx={{
        color:
          roundedTrend > 0
            ? Colors.GREEN
            : roundedTrend == 0
            ? Colors.ORANGE
            : Colors.RED,
      }}
    >
      {roundedTrend > 0 && <span style={{ fontSize }}>+</span>}
      {roundedTrend === 0 && (
        <FiberManualRecord fontSize="small" sx={{ fontSize: 12 }} />
      )}
      <span style={{ fontSize }} className={classes.trendText}>
        {roundedTrend.toFixed(2)}p
      </span>
    </Box>
  );
};

export default PriceTrend;
